import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { Home, Phone } from "lucide-react";
import { COMPANY, LOGOS } from "@/lib/constants";

export default function NotFoundPage() {
  return (
    <div
      className="min-h-screen bg-[#0B1726] text-white flex items-center justify-center px-6"
      data-testid="not-found-page"
    >
      <Helmet>
        <title>Page not found — All Day Power Washing</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <div className="max-w-xl text-center">
        <img src={LOGOS.elephant} alt="" className="h-20 w-20 mx-auto mb-8 opacity-80" />
        <div className="font-heading text-[#E6B445] text-sm font-bold tracking-[0.3em] uppercase mb-4">
          Error 404
        </div>
        <h1 className="font-heading text-5xl sm:text-7xl font-black uppercase tracking-tighter leading-[0.9] mb-6">
          This page <br />
          <span className="text-[#1E88E5]">got power-washed.</span>
        </h1>
        <p className="text-slate-400 text-lg leading-relaxed mb-10">
          We couldn't find what you were looking for — maybe the link is old or
          mistyped. Head home, grab a quote, or call/text us.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            data-testid="nf-home-btn"
            className="inline-flex items-center justify-center gap-2 bg-[#1E88E5] hover:bg-[#42A5F5] text-white font-heading font-bold tracking-wider uppercase px-8 py-4 rounded-sm transition-all"
          >
            <Home className="w-4 h-4" /> Back to Home
          </Link>
          <a
            href={COMPANY.phoneHref}
            data-testid="nf-call-btn"
            className="inline-flex items-center justify-center gap-2 border-2 border-white/20 hover:border-white text-white font-heading font-bold tracking-wider uppercase px-8 py-4 rounded-sm transition-all"
          >
            <Phone className="w-4 h-4" /> {COMPANY.phone}
          </a>
        </div>
      </div>
    </div>
  );
}
